// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"115":"students","389":"404","463":"videos","651":"courses","809":"users","962":"home","966":"login"}[chunkId] + "." + {"115":"2dccee02","389":"cb0c064d","463":"e9219e43","651":"bccd1279","809":"36e6bd30","962":"b39cd27c","966":"daf11d94"}[chunkId] + ".js";
};